import React, { Component } from 'react';
import { Helmet } from 'react-helmet-async';
import AppConfig from 'Constants/AppConfig';
import IntlMessages from 'Util/IntlMessages';
import IconButton from '@mui/material/IconButton';
import { connect } from "react-redux";
import { Table } from 'reactstrap';
import TextField from '@mui/material/TextField';
// page title bar
import PageTitleBar from 'Components/PageTitleBar/PageTitleBar';
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';
import ConfirmationDialog from "Routes/common/ConfirmationDialog";
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import {
    getProgramInclusion1,
    addProgramInclusions,
    deleteProgramInclusions,
    editProgramInclusions
 } from 'Actions';

class ProgramInclusions extends Component {

   constructor(props) {

      super(props);
      this.confirmationDialog = React.createRef();
      this.state = {
         name: '',
         edname:'',
         viewdiv: true,
         adddiv: true,
         lsttype: [],
         selshot: '',
         seltype: '',
         seldrill: '',
         eid: '',

      };
      this.addHandleSubmit = this.addHandleSubmit.bind(this); 
      this.deleteForm = this.deleteForm.bind(this);
      this.editHandleSubmit = this.editHandleSubmit.bind(this);
      this.editProgramInclusions = this.editProgramInclusions.bind(this);
      this.onBackSection = this.onBackSection.bind(this);
   }
   UNSAFE_componentWillMount() {
      this.props.getProgramInclusion1();
   }

   addHandleSubmit(event) {
      event.preventDefault();
      this.props.addProgramInclusions(this.state.name,);
      this.setState({ 
                     name:'',
                  });
   }

   deleteForm(data) {
      this.data = data;
      this.confirmationDialog.current.openDialog();
   }

   deleteDataPermanent(popupResponse) {
      if (popupResponse) {
         this.props.deleteProgramInclusions(this.data.id);
         this.data = "";
      }
   }

   editProgramInclusions(rawdata){
      
      this.setState({
         id:rawdata.id,
         edname:rawdata.name,   
         adddiv:false,
         editdiv:true
      });
   }

   editHandleSubmit(event) {
      event.preventDefault();
      this.props.editProgramInclusions(this.state.edname, this.state.id);      
   }

   onBackSection() {
		this.setState({ adddiv:true,
         editdiv:false });
	}

   render() {
      const { match, programinclusionlist1, loading } = this.props;

      return (
         <>
            <div className="saas-dashboard">
               <Helmet>
                  <title> Program Inclusion | {AppConfig.appTitle}</title>
                  <meta name="description" content="Contract" />
               </Helmet>
               <PageTitleBar title={<IntlMessages id="sidebar.ProgramInclusions" />} match={match} />
               <div className="row">
                  <div className="col-sm-12 col-lg-8">
                     <RctCollapsibleCard heading="List">
                        <div className="table-responsive">
                              <Table hover bordered striped>
                                 <thead>
                                    <tr className="bg-primary text-white">
                                       <th>Sl.No</th>
                                       <th>Name</th>
                                       <th>Action</th>
                                    </tr>
                                 </thead>
                                 <tbody>
                                    {programinclusionlist1.map((data, idx) => (
                                       <tr key={idx}>
                                          <td>{idx + 1}</td>
                                          <td>{data.name}</td>
                                          <td>
                                             <IconButton className="text-info" aria-label="edit" onClick={() => this.editProgramInclusions(data)}><EditOutlinedIcon/></IconButton>
                                             <IconButton className="text-danger" aria-label="Delete" onClick={() => this.deleteForm(data)}><DeleteOutlineOutlinedIcon/></IconButton>
                                          </td>
                                       </tr>
                                    ))}
                                 </tbody>
                              </Table>
                        </div>
                     </RctCollapsibleCard>
                  </div>
                  {this.state.adddiv &&
                     <div className="col-sm-6 col-lg-4">
                        <RctCollapsibleCard heading="Add Program Inclusion">
                           <form autoComplete="off" onSubmit={(e) => this.addHandleSubmit(e)}>
                              <div className="row">
                                 <div className="col-sm-12 col-lg-6 col-xl-12">
                                    <div className="form-group">
                                       <TextField id="name" fullWidth label="New Inclusion" required value={this.state.name} onChange={evt => this.setState({ name: evt.target.value })} />
                                    </div>
                                    <div className="form-group">
                                       <input type="submit" className="mr-3 mb-3 btn btn-outline-primary" value="Submit" />

                                    </div>
                                 </div>
                              </div>
                           </form>
                        </RctCollapsibleCard>
                     </div>
                  }

                  {this.state.editdiv &&
                     <div className="col-sm-6 col-lg-4">
                        <RctCollapsibleCard heading="Edit Program Inclusion">
                           <form autoComplete="off" onSubmit={this.editHandleSubmit}>
                              <div className="row">
                                 <div className="col-sm-12 col-lg-6 col-xl-12">
                                    <div className="form-group">
                                       <TextField id="name" fullWidth label="Name" required value={this.state.edname} onChange={evt => this.setState({ edname: evt.target.value })} />
                                    </div>
                                    <div className="form-group">
                                       <input type="submit" className="mr-3 mb-3 btn btn-outline-primary" value="Update" />
                                       <input type="button" className="mr-3 mb-3 btn btn-outline-warning" onClick={this.onBackSection} value="Back" />

                                    </div>
                                 </div>
                              </div>
                           </form>
                        </RctCollapsibleCard>
                     </div>
                  }
               </div>
               <ConfirmationDialog
               ref={this.confirmationDialog}
               onConfirm={(res) => this.deleteDataPermanent(res)}
               data={'student'}
            />

            </div>
         </>
      );
   }
}
const mapStateToProps = ({ ProgramInclusions }) => {
   const { programinclusionlist1, loading } = ProgramInclusions;
   return { programinclusionlist1, loading };
};

export default connect(mapStateToProps, {
   getProgramInclusion1,
   addProgramInclusions,
   deleteProgramInclusions,
   editProgramInclusions
})(ProgramInclusions);